window.addEventListener('load', function () {
    const accordions = document.querySelectorAll('.wp-block-brblocks-accordion');

    accordions.forEach((accordion) => {
        const title = accordion.querySelector('.accordion-title');
        const content = accordion.querySelector('.accordion-content');
        const anchor = accordion.id; // Corrigé : utiliser l'ID du conteneur principal

        // Fonction pour ouvrir l'accordéon si le hash correspond
        const openAccordion = () => {
            if (window.location.hash === `#${anchor}`) {
                const offset = 100; // Hauteur du header sticky à ajuster selon ton site
                const top = accordion.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({ top, behavior: 'smooth' });

                // Fermer les autres accordéons
                accordions.forEach((acc) => {
                    if (acc !== accordion) {
                        acc.querySelector('.accordion-content')?.classList.remove('open');
                        acc.querySelector('.accordion-title')?.classList.remove('active');
                    }
                });

                // Ouvrir l'accordéon ciblé
                content?.classList.add('open');
                title?.classList.add('active');
            }
        };

        // Vérifie l’ancre au chargement
        openAccordion();

        // Vérifie l’ancre quand le hash change
        window.addEventListener('hashchange', openAccordion);

        // Interaction manuelle sur clic
        if (title) {
            title.addEventListener('click', () => {
                // Fermer les autres
                accordions.forEach((acc) => {
                    if (acc !== accordion) {
                        acc.querySelector('.accordion-content')?.classList.remove('open');
                        acc.querySelector('.accordion-title')?.classList.remove('active');
                    }
                });

                // Toggle l'accordéon cliqué
                content?.classList.toggle('open');
                title?.classList.toggle('active');
            });
        }
    });
});
